import { FileId } from "@inrev/common";
import type { QueryKey } from "@tanstack/react-query";

export const filesQueryKey = (fileId: FileId) => ["files", fileId] as const;

/**
 * Signed download URLs cache under their own leaf — {@link filesQueryKey} holds the file's
 * `UploadedFile` metadata, and `useGetFileUrl` reads and writes its key as a bare URL string.
 */
export const fileDownloadUrlQueryKey = (fileId: FileId) =>
	[...filesQueryKey(fileId), "download-url"] as const;

/**
 * A document viewer's signed URL, under the key its caller gave the file, so invalidating that
 * key refreshes the document on screen.
 */
export const documentUrlQueryKey = (fileKey: QueryKey, purpose: "view" | "download") =>
	[...fileKey, { asDownload: purpose === "download" }] as const;

/** Holds the place of a document viewer's URL query while it has no document. */
export const noDocumentUrlQueryKey = () => ["document-viewer", "no-document"] as const;
